/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ButtonIconSquare/view.blocks to change it.
import "DesignSystem/Fonts/Inter-300.css"
import Children from 'Simple/Children'
import React from 'react'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function ButtonIconSquare({
  children,
  viewPath = "/DesignSystem/ButtonIconSquare",
  height = 280,
  marginLeft = 0,
  onClick,
  width = 250,
  marginTopText = 10,
  text = "",
  isSelected
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
  return (<React.Fragment
>
<button
  data-testid="ButtonIconSquare.ButtonIconSquare"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--h-1-1xBFqK': typeof height === 'number' ? `${height}px` : height,'--ml-2-1xBFqK': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--w-4-1xBFqK': typeof width === 'number' ? `${width}px` : width,'--s-3-1xBFqK': isHovered ? 1.05 : 1}}
 className={`views-block ${styles.ButtonIconSquare1}`}
>
<Children
  viewPath={`${viewPath}/Children`}
 isSelected={isSelected} isHovered={isHovered} isSelectedHovered={isSelectedHovered}
>
{children}
</Children>
<span
  data-testid="ButtonIconSquare.Text"
  data-view-path={viewPath}
 style={{'--mt-5-1xBFqK': typeof marginTopText === 'number' ? `${marginTopText}px` : marginTopText}}
 className={`views-text ${styles.Text}`}
>
{text}
</span>
</button>
</React.Fragment>)
}